import idx from 'idx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers, mapProps } from 'recompose'

import * as routeActions from 'actions/routeActions'

export default compose(
  connect(
    (state) => {
      return {
        pathname: idx(state, _ => _.router.location.pathname),
      }
    },
    (dispatch) => {
      const actions = {
        ...routeActions,
      }

      return {
        actions: bindActionCreators(actions, dispatch),
      }
    },
  ),
  mapProps((props) => {
    const links = props.location && props.location.pathname.indexOf('account') > -1 ? {
      link: '/account/home',
      buttonLabel: 'Go to account',
    } : {
      link: '/login',
      buttonLabel: 'Go to login',
    }

    return {
      ...props,
      ...links
    }
  }),
  // Handlers
  withHandlers({
    handleNavClick: ({ actions, link }) => () => {
      actions.redirect(link)
    },
  }),
)



// WEBPACK FOOTER //
// ./src/containers/account/PageNotFound/PageNotFound.enhancer.js